import OutlineThree from '@assets/icons/outline-three.svg'
import { Icon } from './Icon'

export const OutlineThreeIcon = Icon(OutlineThree)
